'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', 'px;\n  display: inline-block;\n  margin-right: 6px;\n  vertical-align: middle;\n  transform: translateY(-1px);\n'], ['\n  height: ', 'px;\n  display: inline-block;\n  margin-right: 6px;\n  vertical-align: middle;\n  transform: translateY(-1px);\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alipay = require('payment-icons/svg/flat/alipay.svg');

var _alipay2 = _interopRequireDefault(_alipay);

var _amex = require('payment-icons/svg/flat/amex.svg');

var _amex2 = _interopRequireDefault(_amex);

var _default = require('payment-icons/svg/flat/default.svg');

var _default2 = _interopRequireDefault(_default);

var _diners = require('payment-icons/svg/flat/diners.svg');

var _diners2 = _interopRequireDefault(_diners);

var _discover = require('payment-icons/svg/flat/discover.svg');

var _discover2 = _interopRequireDefault(_discover);

var _elo = require('payment-icons/svg/flat/elo.svg');

var _elo2 = _interopRequireDefault(_elo);

var _hipercard = require('payment-icons/svg/flat/hipercard.svg');

var _hipercard2 = _interopRequireDefault(_hipercard);

var _jcb = require('payment-icons/svg/flat/jcb.svg');

var _jcb2 = _interopRequireDefault(_jcb);

var _maestro = require('payment-icons/svg/flat/maestro.svg');

var _maestro2 = _interopRequireDefault(_maestro);

var _mastercard = require('payment-icons/svg/flat/mastercard.svg');

var _mastercard2 = _interopRequireDefault(_mastercard);

var _paypal = require('payment-icons/svg/flat/paypal.svg');

var _paypal2 = _interopRequireDefault(_paypal);

var _unionpay = require('payment-icons/svg/flat/unionpay.svg');

var _unionpay2 = _interopRequireDefault(_unionpay);

var _visa = require('payment-icons/svg/flat/visa.svg');

var _visa2 = _interopRequireDefault(_visa);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getIcon = function getIcon(i) {
  var icons = {
    __unknown: _default2.default,
    Alipay: _alipay2.default,
    Amex: _amex2.default,
    Diners: _diners2.default,
    Discover: _discover2.default,
    Elo: _elo2.default,
    Hipercard: _hipercard2.default,
    Jcb: _jcb2.default,
    Maestro: _maestro2.default,
    MasterCard: _mastercard2.default,
    Paypal: _paypal2.default,
    Unionpay: _unionpay2.default,
    Visa: _visa2.default
  };
  return Object.keys(icons).includes(i) ? icons[i] : icons.__unknown;
};

var Icon = _styledComponents2.default.img(_templateObject, function (_ref) {
  var height = _ref.height;
  return height;
});

var CardIcon = function CardIcon(_ref2) {
  var icon = _ref2.icon,
      height = _ref2.height;
  return _react2.default.createElement(Icon, {
    src: getIcon(icon),
    height: height
  });
};

CardIcon.propTypes = {
  icon: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.number
};
CardIcon.defaultProps = {
  height: 13
};
exports.default = CardIcon;